import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { reportSaleByMunicipalityTypes } from "redux/reducers/Reports/reportSaleByMunicipality/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_SALE_BY_MUNICIPALITY_FILTERS } = reportSaleByMunicipalityTypes;

export const getReportSaleByMunicipalityAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    dispatch(startRequestComp('loadingSaleByMunicipality'));
    try {
      const url = `${process.env.REACT_APP_URL}${PROYECT}/reports/sale-by-municipality?idStation=${station.id}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
      const res = await axios.get(url, {
        headers: { authorization: token },
        responseType: "blob"
      });

      saveAs(res.data, `Reporte_Venta_por_Municipio_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingSaleByMunicipality'));
    }
  };
};

export const setReportSaleByMunicipalityFilters = (key = "", value) => ({
  type: SET_SALE_BY_MUNICIPALITY_FILTERS,
  payload: { key, value }
});
